<!-- Mock HTML for Flextune starts -->
@if (flextuneFormGroup?.contains('CoolCct')) {
  <div class="form" [formGroup]="flextuneFormGroup">
    <div class="col-3 custom-button-led">
      <div class="signifyBookmd">
        <span class="sub-title">LED string configuration</span>
      </div>
    </div>
    <div class="row cool-led-section d-flex align-items-end no-flex-wrap">
      <div class="section-title col-1">
        <span class="signifyBookmd">Cool LED</span>
      </div>
      <div class="section align-section-with-padding">
        <div class="section-input mr-3">
          <div class="input-with-label">
            <span class="input-label signifyBookmd">CCT</span>
            <input
              apInputError
              [formControl]="flextuneFormGroup.get('CoolCct')"
              appOnlynumber
              formControlName="CoolCct"
              type="number"
              class="form-control input-small"
              id="CoolCct"
              />
            </div>
            <span class="unit signifyBookmd">K</span>
          </div>
          <div class="section-input mr-15">
            <div class="input-with-label">
              <span class="input-label signifyBookmd">Rated lumen</span>
              <input
                apInputError
                [formControl]="flextuneFormGroup.get('CoolRatedLm')"
                appOnlynumber
                formControlName="CoolRatedLm"
                type="number"
                class="form-control input-small"
                id="CoolRatedLm"
                />
              </div>
              <span class="unit signifyBookmd">Lm &#64;</span>
            </div>
            <div class="section-input">
              <div class="input-with-label">
                <span class="input-label signifyBookmd">Rated current</span>
                <input
                  apInputError
                  [formControl]="flextuneFormGroup.get('CoolRatedCurrent')"
                  appOnlynumber
                  formControlName="CoolRatedCurrent"
                  type="number"
                  class="form-control input-small"
                  id="CoolRatedCurrent"
                  />
                </div>
                <span class="unit signifyBookmd">mA </span>
              </div>
            </div>
          </div>
          <div class="row warm-led-section d-flex align-items-end no-flex-wrap">
            <div class="section-title col-1 without-label">
              <span class="signifyBookmd">Warm LED</span>
            </div>
            <div class="section align-section-with-padding">
              <div class="section-input mr-3">
                <div class="input-with-label">
                  <input
                    apInputError
                    [formControl]="flextuneFormGroup.get('WarmCct')"
                    formControlName="WarmCct"
                    appOnlynumber
                    type="number"
                    class="form-control input-small"
                    id="WarmCct"
                    />
                  </div>
                  <span class="unit without-label signifyBookmd">K</span>
                </div>
                <div class="section-input mr-15">
                  <div class="input-with-label">
                    <input
                      apInputError
                      [formControl]="flextuneFormGroup.get('WarmRatedLm')"
                      formControlName="WarmRatedLm"
                      appOnlynumber
                      type="number"
                      class="form-control input-small"
                      id="WarmRatedLm"
                      />
                    </div>
                    <span class="unit without-label signifyBookmd">Lm &#64;</span>
                  </div>
                  <div class="section-input">
                    <div class="input-with-label">
                      <input
                        apInputError
                        [formControl]="flextuneFormGroup.get('WarmRatedCurrent')"
                        formControlName="WarmRatedCurrent"
                        appOnlynumber
                        type="number"
                        class="form-control input-small"
                        id="WarmRatedCurrent"
                        />
                      </div>
                      <span class="unit without-label signifyBookmd">mA </span>
                    </div>
                  </div>
                </div>
                <div class="light-level-config-section">
                  <div class="signifyBookmd light-level-title">
                    <span class="sub-title">Light level configuration</span>
                  </div>
                  <div class="section-item input-item light-output-section">
                    <div class="signifyBookmd input-label col-1">
                      <div class="nowrap">Light output on</div>
                      <div>CCT range</div>
                    </div>
                    <div class="input-field">
                      <select
                        formControlName="LightOutputOverCct"
                        class="signifyBookmd select-light-output"
                        id="LightOutputOverCct"
                        >
                        @for (item of allDropDownItems['LightOutputOverCct']; track item) {
                          <option
                            [value]="item"
                            class="info-val"
                            >
                            {{ item }}
                          </option>
                        }
                      </select>
                    </div>
                  </div>
                  <div class="section-item input-item">
                    <div class="signifyBookmd input-label col-1">Cool LED</div>
                    <div class="input-field col-3">
                      <input
                        formControlName="coolLightRatedLumen"
                        type="number"
                        class="form-control input-small"
                        id="coolLightRatedLumen"
                        />
                        <span class="unit signifyBookmd">Lm &#64;</span>
                      </div>
                    </div>
                    <ng-container
                      [ngTemplateOutlet]="sliderWithInputField"
      [ngTemplateOutletContext]="{
        propertyName: 'CoolAOC',
        unit: 'mA',
        propertyTitle: 'AOC'
      }"
                    ></ng-container>
                    <div class="section-item input-item">
                      <div class="signifyBookmd input-label col-1">Warm LED</div>
                      <div class="input-field flex-display align-center justify-start col-3">
                        <input
                          formControlName="warmLightRatedLumen"
                          type="number"
                          class="form-control input-small"
                          id="warmLightRatedLumen"
                          />
                          <span class="unit signifyBookmd">Lm &#64;</span>
                        </div>
                      </div>
                      <ng-container
                        [ngTemplateOutlet]="sliderWithInputField"
      [ngTemplateOutletContext]="{
        propertyName: 'WarmAOC',
        unit: 'mA',
        propertyTitle: 'AOC'
      }"
                      ></ng-container>
                    </div>
                    <div class="additional-color-config-section">
                      <div
                        class="signifyBookmd additional-color-level-title"
      [ngClass]="{
        'standard-mode-additional-title': quickConfigvalue
      }"
                        >
                        <span class="sub-title">Additional color configuration</span>
                      </div>
                      @if (isIndoor) {
                        <ng-container
                          [ngTemplateOutlet]="sliderWithInputField"
      [ngTemplateOutletContext]="{
        propertyName: 'PowerOnCct',
        unit: 'K',
        propertyTitle: 'Power on CCT'
      }"
                        ></ng-container>
                      }
                      @if (isIndoor) {
                        <ng-container
                          [ngTemplateOutlet]="sliderWithInputField"
      [ngTemplateOutletContext]="{
        propertyName: 'SystemFailureCct',
        unit: 'K',
        propertyTitle: 'System failure CCT'
      }"
                        ></ng-container>
                      }
                      @if (isIndoor) {
                        <ng-container
                          [ngTemplateOutlet]="sliderWithInputField"
      [ngTemplateOutletContext]="{
        propertyName: 'CctCoolest',
        unit: 'K',
        propertyTitle: 'CCT coolest'
      }"
                        ></ng-container>
                      }
                      @if (isIndoor) {
                        <ng-container
                          [ngTemplateOutlet]="sliderWithInputField"
      [ngTemplateOutletContext]="{
        propertyName: 'CctWarmest',
        unit: 'K',
        propertyTitle: 'CCT warmest'
      }"
                        ></ng-container>
                      }
                      <ng-container
                        [ngTemplateOutlet]="sliderWithInputField"
      [ngTemplateOutletContext]="{
        propertyName: 'CctOffset',
        unit: 'K',
        propertyTitle: 'CCT offset (+/-)'
      }"
                      ></ng-container>
                    </div>
                  </div>
                }

                <ng-template
                  #sliderWithInputField
                  let-propertyName="propertyName"
                  let-propertyTitle="propertyTitle"
                  let-unit="unit"
                  >
                  @if (flextuneFormGroup.get(propertyName) && propertiesInfo[propertyName]) {
                    <div
                      class="section-item slider-item input-item"
                      [formGroup]="flextuneFormGroup"
    [ngClass]="{
      isResetDisabled: !isControlEnabled(propertyName)
    }"
                      >
                      <div class="input-label slider-title col-1">
                        @if (propertyTitle != 'System failure CCT') {
                          <span
                            class="signifyBookmd"
                            >{{ propertyTitle }}</span
                            >
                        }
                        @if (propertyTitle == 'System failure CCT') {
                          <div class="nowrap">
                            System failure
                          </div>
                        }
                        @if (propertyTitle == 'System failure CCT') {
                          <div>CCT</div>
                        }
                      </div>
                      @if (quickConfigvalue) {
                        <div class="col-2">
                          <div class="row">
                            <div class="col-2"></div>
                            <div class="col-2 minValMargin">
                              <span class="signifyBookmd minValue">
                                min {{ propertiesInfo[propertyName].sliderMin }}</span
                                >
                              </div>
                              <div class="col-3">
                                <span class="signifyBookmd maxValue">
                                  max {{ propertiesInfo[propertyName].sliderMax }}</span
                                  >
                                </div>
                              </div>
                            </div>
                          }
                          @if (!quickConfigvalue) {
                            <div class="minvalue col-1">
                              <span class="signifyBookmd">{{
                                propertiesInfo[propertyName].sliderMin
                              }}</span>
                            </div>
                          }
                          @if (!quickConfigvalue) {
                            <div
                              class="col-6 curvePadding sliderCss slider-container"
                              >
                              <ngx-slider
                                type="normalType"
                                class="slider-element"
                                [options]="propertiesInfo[propertyName].options"
                                [(value)]="propertiesInfo[propertyName]['value']"
                                (userChangeEnd)="onSliderValueChange($event.value, propertyName)"
                                ngDefaultControl
                                >
                              </ngx-slider>
                            </div>
                          }
                          @if (!quickConfigvalue) {
                            <div class="maxvalue col-1">
                              <span class="signifyBookmd">{{
                                propertiesInfo[propertyName].sliderMax
                              }}</span>
                            </div>
                          }
                          <div class="row form-group col-4">
                            <div class="d-flex align-items-center">
                              <input
                                [allowNegative]="propertyName=='CctOffset'"
                                apInputError
                                [formControl]="flextuneFormGroup.get(propertyName)"
                                appOnlynumber
                                [formControlName]="propertyName"
                                type="number"
                                [id]="propertyName"
          [ngClass]="{
            'quick-custom-inputbox textBoxUnit' :quickConfigvalue,
            'custom-inputbox': !quickConfigvalue
          }"
                                class="form-control input-small signifyBookmd textbox-standard"
                                />
                                <p class="signifyBookmd mb-0 ml-2" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">{{ unit }}</p>
                              </div>
                            </div>
                          </div>
                        }
                      </ng-template>
